import { SearchParams } from './types';

export const EMPTY_SEARCH: SearchParams = {
  q: '',
  categoryGroupId: 0,
  min: 0,
  max: 0,
  // Undefined deletes the key in setSearchParams, so a sort picked on one
  // search does not carry into "load more" on the next.
  sortBy: undefined,
};

export const ITEMS_PER_PAGE = 32;

export const SCROLL_THRESHOLD = 1; // window.innerHeight multiplier for scroll class
